/**
 * Card Color Swatches — swaps card product image on swatch click.
 * Progressive enhancement: without JS, swatches are plain links to the variant URL.
 */
class CardSwatches extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll('.card-swatches__swatch[data-variant-image]');
    this.card = this.closest('.card-wrapper');
    this.primaryImage = this.card?.querySelector('.card__media .media img:first-child');
  }

  connectedCallback() {
    if (!this.primaryImage || this.swatches.length === 0) return;

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', this.onSwatchClick.bind(this));
      swatch.addEventListener('mouseenter', this.onSwatchHover.bind(this));
    });
  }

  onSwatchClick(event) {
    event.preventDefault();
    const swatch = event.currentTarget;
    this.swapImage(swatch);
    this.setActive(swatch);

    // Update the card link to point to this variant
    const cardLinks = this.card.querySelectorAll('a.full-unstyled-link, .card__image-overlay a');
    const variantUrl = swatch.getAttribute('href');
    cardLinks.forEach((link) => {
      link.setAttribute('href', variantUrl);
    });
  }

  onSwatchHover(event) {
    const swatch = event.currentTarget;
    const imgSrc = swatch.dataset.variantImage;
    if (imgSrc) {
      // Preload on hover
      const preload = new Image();
      preload.src = imgSrc;
    }
  }

  swapImage(swatch) {
    const newSrc = swatch.dataset.variantImage;
    const newSrcset = swatch.dataset.variantImageSrcset;

    if (!newSrc) return;

    this.primaryImage.src = newSrc;
    if (newSrcset) {
      this.primaryImage.srcset = newSrcset;
    }
  }

  setActive(activeSwatch) {
    this.querySelectorAll('.card-swatches__swatch').forEach((s) => {
      s.classList.remove('card-swatches__swatch--active');
    });
    activeSwatch.classList.add('card-swatches__swatch--active');
  }
}

if (!customElements.get('card-swatches')) {
  customElements.define('card-swatches', CardSwatches);
}
